<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-img src="@/assets/img/logo.jpg" width="200" height="200" class="logo-login"/>
          </v-col>
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $t('login.title') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-alert type="error" v-if="error">{{ error }}</v-alert>
                <v-form ref="form" v-model="valid">
                  <v-text-field
                    autocomplete="email"
                    :label="$t('forms.email')"
                    prepend-icon="person"
                    type="text"
                    v-model="email"
                    :rules="emailRules"
                    @keyup.native.enter="login"
                    required
                  />

                  <v-text-field
                    autocomplete="current-password"
                    :label="$t('forms.password')"
                    prepend-icon="lock"
                    type="password"
                    v-model="password"
                    @keyup.native.enter="login"
                    :rules="passwordRules"
                    required
                  />

                  <v-checkbox
                    v-model="remember"
                    :label="$t('login.remember')"
                    off-icon="radio_button_unchecked"
                    on-icon="check_circle"
                  ></v-checkbox>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  color="primary"
                  class=""
                  @click="forgotPassword"
                  v-show="!loading"
                >
                  {{ $t('login.forgot-password') }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  class="pl-5"
                  @click="login"
                  :loading="loading"
                >
                  {{ $t('login.login') }}
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <v-dialog persistent v-model="dialog_forgot" max-width="500">
        <v-card>
            <v-card-title class="headline">{{ $t('login.recovery.title') }}</v-card-title>
            <v-card-text>
              <v-alert type="error" v-if="error">{{ error }}</v-alert>
              <v-alert type="success" v-if="success">{{ success }}</v-alert>
              <p>{{ $t('login.recovery.description') }}</p>
              <v-form ref="formForgot" v-model="validForgot">
                <v-text-field
                autocomplete="forgot-email"
                :label="$t('login.email')"
                prepend-icon="mail_outline"
                type="text"
                v-model="emailForgot"
                @keyup.native.enter="recoveryPassword"
                :rules="emailRules"
                required
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancelRecovery">
                    {{ $t('login.recovery.back-login') }}
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  @click="recoveryPassword"
                  v-if="!success"
                >
                  {{ $t('login.recovery.recovery') }}
                </v-btn>
            </v-card-actions>
            <v-overlay
              :value="loading"
              >
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-overlay>
        </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import firebase from "firebase"

export default {
  data() {
    return {
      loading: false,
      valid: false,
      validForgot: false,
      emailForgot: '',
      email: '',
      password: '',
      error: null,
      success: null,
      remember: false,
      dialog_forgot: false,
      emailRules: [
        v => !!v || this.$t("forms.is-required", { name: this.$t("forms.email") }),
        v => /.+@.+/.test(v) || this.$t("forms.must-valid", { name: this.$t("forms.email") })
      ],
      passwordRules: [
        v =>
          !!v ||
          this.$t("forms.is-required", { name: this.$t("login.password") })
      ]
    }
  },

  created: function() {
    if (this.$store.getters.user.loggedIn) {
      if (this.$router.currentRoute.name !== "Dashboard") {
        this.$router.push({ name: "Dashboard" })
      }
    } else {
      if (this.$router.currentRoute.name !== "Login") {
        this.$router.push({ name: "Login" })
      }
    }
  },

  methods: {
    cancelRecovery() {
      this.dialog_forgot = false
      this.loading = false
      this.emailForgot = ''
      this.error = null
      this.success = null
      this.$refs.formForgot.reset()
    },
    recoveryPassword() {
      this.loading = true
      if (this.$refs.formForgot.validate()) {
        firebase
        .auth()
        .sendPasswordResetEmail(this.emailForgot)
        .then(() => {
          this.success = this.$t('login.recovery.success')
          this.loading = false
        })
        .catch(error => {
          let message = ''
          switch (error.code) {
            case 'auth/invalid-email':
            message = this.$t('errors.auth.invalid-email')
            break
          case 'auth/user-not-found':
            message = this.$t('errors.auth.user-not-found')
            break
          default:
            message = error.message
            break
          }

          this.success = null
          this.error = message
          this.loading = false
        })
      } else {
        this.loading = false
      }
    },
    forgotPassword() {
      this.success = null
      this.error = null
      this.$refs.form.reset()
      this.dialog_forgot = true
    },
    login() {
      this.loading = true
      if (this.$refs.form.validate()) {
        firebase.auth().setPersistence(this.remember ? firebase.auth.Auth.Persistence.LOCAL : firebase.auth.Auth.Persistence.SESSION)
        .then(() => {
          firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            if (this.$router.currentRoute.name !== "Dashboard") {
              this.$router.push({ name: "Dashboard" })
            }
          })
          .catch(error => {
            let message = ''
            switch (error.code) {
              case 'auth/wrong-password':
              message = this.$t('errors.auth.wrong-password')
              break
              case 'auth/invalid-email':
              message = this.$t('errors.auth.invalid-email')
              break
              case 'auth/user-disabled':
              message = this.$t('errors.auth.user-disabled')
              break
              case 'auth/user-not-found':
              message = this.$t('errors.auth.user-not-found')
              break
              default:
              message = error.message
              break
            }

            this.error = message
            this.loading = false
          })
        })
        .catch(error => {
          this.error = error.message
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}

</script>
